import { createFileRoute } from '@tanstack/react-router';
import { type AggregateBreadcrumb, buildBreadcrumb } from '@interxfi/app-components/components/router-breadcrumbs/router-breadcrumbs';
import { INCREASE_ACH_BASE_PATH } from '../../../../../../../../../features/vendor/increase/ach/increase-ach-routing';

export const Route = createFileRoute('/_app/_clearing-core/_clearing-required/clearing/vendor/_vendor/increase/ach/_ach')({
  loader: () =>
    ({
      breadcrumb: buildBreadcrumb({
        id: 'increase-ach-list',
        label: 'Increase',
        to: INCREASE_ACH_BASE_PATH,
      }),
    }) satisfies AggregateBreadcrumb,
});
